/**
 * Amazon provider writes are unsupported until later authorization tickets.
 * Fail closed: listing create, publish, inventory, price, and order actions.
 */

import { AMAZON_PROVIDER, isAmazonProvider } from "./amazon-au";

export const AMAZON_WRITES_UNSUPPORTED_CODE = "AMAZON_WRITES_UNSUPPORTED";

export const AMAZON_WRITES_UNSUPPORTED_MESSAGE =
  "Amazon listing, inventory, price, and order writes are not configured.";

export type AmazonWriteGuardResult =
  | { allowed: true }
  | { allowed: false; code: typeof AMAZON_WRITES_UNSUPPORTED_CODE; error: string };

export function assertAmazonProviderWriteAllowed(provider: string | null | undefined): AmazonWriteGuardResult {
  if (!isAmazonProvider(provider)) return { allowed: true };
  return {
    allowed: false,
    code: AMAZON_WRITES_UNSUPPORTED_CODE,
    error: AMAZON_WRITES_UNSUPPORTED_MESSAGE,
  };
}

export function amazonProviderWriteBlocked(provider: string | null | undefined): boolean {
  return assertAmazonProviderWriteAllowed(provider).allowed === false;
}

export const AMAZON_WRITE_CAPABILITIES_DENIED = {
  provider: AMAZON_PROVIDER,
  publish_inventory: false,
  publish_fulfillment: false,
  import_orders: false,
  import_products: false,
} as const;
